import { useLayoutEffect } from "react";
import type { RefObject } from "react";
import * as THREE from "three";
import { zIndexEpsilon } from "../../types/floorplannerTypes";

const WALL_OUTLINE_RENDER_PLANE_Z = 0.002;
const WALL_ATTACHMENT_RENDER_ORDER_BASE = 2000;

export const getWallAttachmentZOffset = (
  attachedToWall: boolean,
  zIndex: number,
) => attachedToWall ? WALL_OUTLINE_RENDER_PLANE_Z : zIndex * zIndexEpsilon;

export const getWallAttachmentRenderOrder = (zIndex: number) =>
  WALL_ATTACHMENT_RENDER_ORDER_BASE + zIndex;

export const usePlanarWallAttachmentLayer = (
  ref: RefObject<THREE.Object3D | null>,
  active: boolean,
  renderOrder: number,
) => {
  useLayoutEffect(() => {
    const root = ref.current;
    if (!root || !active) {
      return;
    }

    root.traverse((object) => {
      object.renderOrder = renderOrder;

      const material = (object as THREE.Object3D & {
        material?: THREE.Material | THREE.Material[];
      }).material;

      if (!material) {
        return;
      }

      const materials = Array.isArray(material) ? material : [material];
      materials.forEach((item) => {
        item.depthTest = false;
        item.depthWrite = false;
        item.needsUpdate = true;
      });
    });
  });
};
